module.exports = require('./helpers/bundle-url').getBundleURL('b8rBz') + "logo-dark.eefe0b7f.svg";